
    import './styles.scoped.css';
    export default {
  "toggle-button": "awsui_toggle-button_16w0h_5k5pi_99",
  "close-button": "awsui_close-button_16w0h_5k5pi_134"
};
  